package com.neurobs.ccab.casr

import com.neurobs.ccab.casr.CasrDatabaseJSON.ReviewedTestTranscriptJSON
import com.neurobs.util.{Guid, SecondsTimestamp}


case class AccountSubjectTestTranscriptView
(
  accountSubjectId: Long,
  accountId: Long,
  subjectId: Long,
  reportingId: Guid,
  studyId: Long,
  sessionId: Long,
  testRunId: Long,
  testTranscriptId: Long
)

case class ReviewedTestTranscriptMetadata
(
  reviewedTestTranscriptId: Long,
  createdAt: SecondsTimestamp,
  testRunId: Long,
  userId: Long,
  forLatency: Boolean,
  username: String
)

case class TestTranscriptMetadata
(
  testTranscriptId: Long,
  testRunId: Long,
  sessionId: Long,
  createdAt: SecondsTimestamp,
  accountSubjectId: Long,
  reportingId: Guid,
  subjectId: Guid,
  testId: Long,
  testName: String,
  testIdentifier: String,
  studyName: String,
  studyType: String,
  casrReleaseId: Long
)

case class TRTSearchResults
(
  testTranscripts: Seq[TestTranscriptMetadata],
  reviewedTranscripts: Seq[ReviewedTestTranscriptMetadata]
)

case class ReviewerView
(
  userId: Long,
  username: String,
  testRunId: Long,
  reviewedTestTranscriptId: Long
)

case class SpeechAudioFileUploadData
(
  testRunId: Long,
  filename: String,
  location: Option[String]
)

case class ReviewedTestTranscriptCreateData
(
  testRunId: Long,
  userId: Long,
  reviewedTestTranscript: ReviewedTestTranscriptJSON,
  forLatency: Boolean
)

case class ReviewedTestTranscriptUpdateData
(
  id: Long,
  reviewedTestTranscript: ReviewedTestTranscriptJSON,
  forLatency: Boolean
)

case class TestTranscriptMetrics
(
  totalCount: Int,
  errorCount: Int,
  awaitingSyncCount: Int,
)

case class ReviewedTestTranscriptMetrics
(
  totalCount: Int,
  awaitingSyncCount: Int
)

case class TranscriptMetrics
(
  testTranscriptMetrics: TestTranscriptMetrics,
  reviewedTestTranscriptMetrics: ReviewedTestTranscriptMetrics
)





